import { State, Action, StateContext, Store } from '@ngxs/store';
import {
  PostAttachment,
  GetAttachments,
  UploadToS3,
  DownloadFromS3,
  DeleteAttachments,
  UpdateAttachments
} from './actions/attachments.actions'
import { AttachmentsService } from 'src/app/shared/services/attachments.service';
import { HttpClient } from '@angular/common/http';
import { Attachment } from 'src/app/shared/model/attachment';

export class AttachmentStateModel {
    isLoading: boolean;
    attachments: {
      [emailId: string]: {
        attachmentList: Array<Attachment>;
      };
    };
  }

@State<AttachmentStateModel>({
  name: 'attachments',
  defaults: {
    isLoading: false,
    attachments: {}
  }
})
export class AttachmentState {

  constructor(
    private attachmentService: AttachmentsService,
    private httpClient: HttpClient,
    private store: Store,
  ) { }

  @Action(PostAttachment)
  postAttachment(
    ctx: StateContext<AttachmentStateModel>,
    action: PostAttachment
  ) {
    const { body } = action;
    return this.attachmentService.postAttachments(body).then((res: Attachment) => {
      const state = ctx.getState();
      console.log(state.attachments);
      ctx.setState({
        ...state,
        isLoading: false,
        attachments: {
          ...state.attachments,
          [body.EmailId]: {
            attachmentList: [
              ...state.attachments[body.EmailId].attachmentList,
              res
            ]
          }
        }
      });

    });
  }

  @Action(GetAttachments)
  getAttachments(
    ctx: StateContext<AttachmentStateModel>,
    action: GetAttachments
  ) {
    const state = ctx.getState();
    const params = {
      ...action
    };

    ctx.setState({
      ...state,
      isLoading: true
    });

    return this.attachmentService
      .getAttachments(params)
      .then((res: Array<Attachment>) => {


        ctx.setState({
          ...state,
          isLoading: false,
          attachments: {
            ...state.attachments,
            [action.emailId]: { attachmentList: res }
          }
        });

        })
      .catch(e => console.error('get attachments error', e));
  }

  @Action(UploadToS3)
  async uploadToS3(
    ctx: StateContext<AttachmentStateModel>,
    action: UploadToS3
  ) {
    const { emailId, file } = action;
    const state = ctx.getState();
    ctx.setState({
      ...state,
      isLoading: true
    });

    Promise.all(file.map(async file => {
      const key = `${emailId}/${file.name.replace(/ /g,'_').replace(/&/g,'And').replace(/[|&;$%@"<>()+,']/g, '')}`;
      const { Id, presignedURL } = await this.attachmentService.generateS3UploadURL({
        fileName: key,
        contentType: file.type
      });
      this.attachmentService.putFileToS3(file, presignedURL, Id);
      return { file, presignedURL, Id, key };
    })
    ).then(fileArray => {
      fileArray.map(fileResult => {
        const { file, presignedURL, Id, key } = fileResult;
        const trimmedURL = presignedURL.substring(0, presignedURL.indexOf('?'));
        ctx.dispatch(
          new PostAttachment({
            URL: trimmedURL,
            FileName: file.name.replace(/ /g,'_').replace(/&/g,'And').replace(/[|&;$%@"<>()+,']/g, ''),
            Size: file.size,
            Order: 0,
            Key: key,
            EmailId: emailId,
            S3PresignedURL: trimmedURL,
            Id
          })
        );
      })
    }).catch(e => {
      ctx.setState({
        ...state,
        isLoading: false
      });
      console.error('Upload to S3 Error:', e);
    });
  }

  @Action(DownloadFromS3)
  downloadFromS3(
    ctx: StateContext<AttachmentStateModel>,
    action: DownloadFromS3
  ) {
    const { EmailId, FileName } = action.attachment;
    const key = `${EmailId}/${FileName}`;
    return this.attachmentService
      .generateS3DownloadURL({ key })
      .then(URL => {
        this.httpClient
          .get(URL, { responseType: 'blob' })
          .toPromise()
          .then(res => {
            const dataType = res.type;
            const binaryData = [];
            binaryData.push(res);
            const downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(
              new Blob(binaryData, { type: dataType })
            );
            if (FileName) {
              downloadLink.setAttribute('download', FileName);
            }
            document.body.appendChild(downloadLink);
            downloadLink.click();
          });
      });
  }

  @Action(DeleteAttachments)
  deleteAttachment(
    ctx: StateContext<AttachmentStateModel>,
    action: DeleteAttachments
  ) {
    const { attachments } = action;
    if (attachments.length) {
      const state = ctx.getState();
      ctx.setState({
        ...state,
        isLoading: true
      });
      return Promise.all(
        attachments.map(attachment =>
          this.attachmentService.deleteAttachment({ id: attachment.Id })
        )
      )
        .then(res => {
          const emailId = attachments[0].EmailId;
          const newAttachment = {
            attachmentList : state.attachments[emailId].attachmentList.filter(
              attachment => !attachments.includes(attachment)
            )
          };
          ctx.setState({
            ...state,
            attachments: { ...state.attachments, [emailId]: newAttachment },
            isLoading: false
          });
        })
        .catch(e => {
          console.error('Delete Attachment error', e);
          ctx.setState({
            ...state,
            isLoading: false
          });
        });
    } else {
      return;
    }
  }

  @Action(UpdateAttachments)
  updateAttachments(
    ctx: StateContext<AttachmentStateModel>,
    action: UpdateAttachments
  ) {
    const { attachments } = action;
    if (attachments.length) {
      const emailId = attachments[0].EmailId;
      const state = ctx.getState();
      ctx.setState({
        ...state,
        isLoading: true
      });
      return this.attachmentService.updateAttachmentArray(attachments, { id: attachments[0].Id })
        .then(res => {
          ctx.setState({
            ...state,
            attachments: {
              ...state.attachments, [emailId]: {
                attachmentList: attachments,
              }
            },
            isLoading: false
          });
        });
    } else {
      return;
    }
  }
}
